import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StepperComponent } from '@progress/kendo-angular-layout';
import { Appraisal, AppraisalDto, ApprovalList, EmployeeAssesment, Hike, HikeDto, MetricDto, PerformanceDto, PromotionDto } from 'src/app/shared/models/appraisal';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { ApprovalCommentComponent } from './approval-comment/approval-comment.component';
import { ApprovalHikeComponent } from './approval-hike/approval-hike.component';
import { ApprovalMatrixComponent } from './approval-matrix/approval-matrix.component';
import { ApprovalPerformanceComponent } from './approval-performance/approval-performance.component';
import { ApprovalPromotableComponent } from './approval-promotable/approval-promotable.component';
import { ApprovalRatingsComponent } from './approval-ratings/approval-ratings.component';
import { CompanyService } from 'src/app/shared/services/company.service';
import { Employee, EmployeeData, Message, User } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
@Component({
    selector: 'app-manage-approval',
    templateUrl: './manage-approval.component.html',
    styleUrls: ['./manage-approval.component.scss']
})
export class ManageApprovalComponent implements OnInit {

    @ViewChild(ApprovalRatingsComponent) rating!: ApprovalRatingsComponent;
    @ViewChild(ApprovalPerformanceComponent) performance!: ApprovalPerformanceComponent;
    @ViewChild(ApprovalMatrixComponent) matrics!: ApprovalMatrixComponent;
    @ViewChild(ApprovalHikeComponent) hike!: ApprovalHikeComponent;
    @ViewChild(ApprovalPromotableComponent) promotable!: ApprovalPromotableComponent;
    @ViewChild(ApprovalCommentComponent) comments!: ApprovalCommentComponent;
    @ViewChild('stepper', { static: true })

    public stepper: StepperComponent;
    public employeeAssesment!: EmployeeAssesment;
    public appraiseeId: number;
    public appraisalId: number;
    public appraisalStatus: string = "";

    public isLoading: boolean = true;
    public activeAppraisalId: number;
    public hikeValue: number;
    public promotableValue: boolean;
    public performanceLabel: string;
    public promotableEmp: boolean;
    public matricsName: string;
    public currentStep = 0;
    public showSaveButton: boolean = false;
    public isActive: boolean;
    private sumbitted = false;
    public employee: EmployeeData;
    public appraisal: Appraisal;
    public hikes: Hike[];
    public promotions: PromotionDto[];
    private shouldValidate = (): boolean => {
        return this.sumbitted === true;
    };

    public steps = [
        {
            label: 'Ratings',
            validate: this.shouldValidate
        },
        {
            label: 'Performance',
            validate: this.shouldValidate
        },
        {
            label: 'Metrics',
            validate: this.shouldValidate
        },
        {
            label: 'Hike',
            validate: this.shouldValidate
        },
        {
            label: 'Promotable',
            validate: this.shouldValidate
        },
        {
            label: 'Comments',
            validate: this.shouldValidate
        }
    ];

    constructor(
        private appraisalService: ApparaisalService,
        private route: ActivatedRoute,
        private companyService: CompanyService,
        private commonService: CommonService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.employee = { employeeData: {} as Employee, userData: {} as User };
        this.appraisal = {} as Appraisal;
        this.employeeAssesment = {
        } as EmployeeAssesment;

        this.initData();
        if (this.hikes?.length > 0) {
            this.hikeValue = this.hikes[0].value || 0;
        }
    }

    private initData() {
        this.route.queryParams.subscribe(params => {
            this.appraiseeId = params['aprId'];
            this.appraisalId = params['aplId'];
            const status = params['status'];
            this.appraisalStatus = status;
            if (params && this.appraiseeId && this.appraisalId) {
                this.isActive = this.commonService.isAssesmentCompleted(status);
                this.getEmployeeAssessment();
                this.getEmployee(this.appraiseeId);
                this.getAppraisal(this.appraisalId);
            }
        });
    }

    private getEmployee(id: number) {
        this.companyService.getEmployee(id).subscribe(employee => this.employee = employee);
    }

    private getAppraisal(id: number) {
        this.appraisalService.getAppraisal(id).subscribe(appraisal => this.appraisal = appraisal);
    }
    private getHike(id: number) {
        this.appraisalService.getHike(id).subscribe(hikes => {
            this.hikes = hikes;
            if (this.hikes && this.hikes.length > 0) {
                this.hikeValue = this.hikes[0].value || 0;
            }
        });
    }

    private getPromotable(id: number) {
        this.appraisalService.getPromotions(id).subscribe(promotions => {
            this.promotions = promotions;
            if (this.promotions && this.promotions.length > 0) {
                this.promotableValue = this.promotions[0].promotable;
            }
        });
    }

    public getEmployeeAssessment(loadObjectives?: boolean, initHike: boolean = true) {
        if (!this.appraisalId || !this.appraiseeId) return;
        this.appraisalService.getEmployeeAppraisalDetails(this.appraisalId, this.appraiseeId).subscribe({
            next: (employeeAssesment: EmployeeAssesment) => {
                this.employeeAssesment = employeeAssesment;
                this.updateUrlParams(this.employeeAssesment.status);
                if (initHike) {
                    this.getHike(employeeAssesment.id)
                    this.getPromotable(employeeAssesment.id)
                }
            }
        });
        if (!loadObjectives) this.rating?.getEmployeeObjectives();
    }

    private updateUrlParams(status: string): void {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { status },
            queryParamsHandling: 'merge',
        });
    }

    public onCommentSubmit(message: any) {
        this.getEmployeeAssessment(true);
    }

    public handleWizardControls(index: any) {
        this.currentStep = index;
        const inithike: boolean = index == 1 || index == 2 || index == 3 || index == 6 ? false : true;
        this.getEmployeeAssessment(true, inithike);
    }

    public next(): void {
        if (this.currentStep === 0) {
            this.rating.saveApproval();
            if (this.isActive) {
                this.currentStep += 1;
            }
        }
        else if (this.currentStep === 1) {
            if (this.isActive) {
                this.currentStep += 1;
            }
            this.performance.upsertPerformance();
        }
        else if (this.currentStep === 2) {
            if (this.isActive) {
                this.currentStep += 1;
            }
            this.matrics.upsertMetrics();
        }
        else if (this.currentStep === 3) {
            if (this.isActive) {
                this.currentStep += 1;
            }
            this.hike.saveHike();
        }
        else if (this.currentStep === 4) {
            if (this.isActive) {
                this.currentStep += 1;
            }
            this.promotable.savePromotion();
        }
        else if (this.currentStep === 5) {
            if (this.isActive) {
                this.currentStep += 1;
            }
            this.comments.upsertComment();
        }
        // else if (this.currentStep === 0) {
        //     return;
        // }
    }

    public handlerating(obj) {
        if (obj) {
            this.currentStep += 1;
        }
    }
    public handleperformance(per) {
        if (per) {
            this.currentStep += 1;
        }
    }
    public handlematrics(met) {
        if (met) {
            this.currentStep += 1;
        }
    }

    public handlehike(hike) {
        if (hike) {
            this.currentStep += 1;
        }
    }
    public handlepromotable(promotion) {
        if (promotion) {
            this.currentStep += 1;
        }
    }
    public handlecomments(comments) {
        if (comments) {
            this.currentStep += 1;
        }
    }

    public prev(): void {
        if (this.currentStep === 5) {
            this.currentStep -= 1;
            if (this.employeeAssesment.loneComments) {
                this.currentStep -= 1;
                this.promotable?.setPromotionForm();
            }
        } else if (this.currentStep === 4) {
            if (this.promotable?.promotionForm) {
                this.currentStep -= 1;
            }
        } else if (this.currentStep === 3) {
            if (this.hike?.hikeForm) {
                this.currentStep -= 1;

            }
        } else if (this.currentStep === 2) {
            if (this.matrics) {
                this.currentStep -= 1;
            }
        } else if (this.currentStep === 1) {
            if (this.performance) {
                this.currentStep -= 1;
            }
        } else if (this.currentStep === 0) {
            return;
        }
        this.getEmployeeAssessment();
    }

    public submit(): void {
        this.sumbitted = true;
        if (this.sumbitted = true && !this.employeeAssesment.loneComments) {
            return;
        }
        else if (this.employeeAssesment.loneComments) {
            this.comments?.upsertComment();
            this.getEmployeeAssessment();
            this.currentStep = 0;
        }
        this.getEmployeeAssessment();
    }

}
